import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IReleaseNotes } from '../interfaces/IReleaseNotes';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesService {
  private http = inject(HttpClient);

  private releaseNotesApi = environment.apiUrl + 'ReleaseNotes/';

  public getAllReleaseNotes(): Observable<IReleaseNotes[]> {
    return this.http.get<IReleaseNotes[]>(this.releaseNotesApi + 'GetAll');
  }

  public getRecentReleaseNote(): Observable<IReleaseNotes> {
    return this.http.get<IReleaseNotes>(this.releaseNotesApi + 'GetRecent');
  }
}
